import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginTop: theme.spacing(.5),
    marginBottom: theme.spacing(.5),
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

export default function SearchBar({ target, fullSet, updateFunction, matchOn }) {
  const classes = useStyles();
  const changeFunction = e => {
    updateFunction(fullSet.filter(elem => elem[matchOn].toLowerCase().search(e.target.value.toLowerCase()) >= 0 ? elem : null))
  }
  return (
    <Paper component="form" className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder={`Search ${target}`}
        inputProps={{ 'aria-label': `search ${target}` }}
        onChange={changeFunction}
      />
      <IconButton type="submit" className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}